import React from "react";

import * as d3 from "d3";
import { useIntl } from "react-intl";

import * as S from "./styles";

type OutOfRetentionProps = {
  retention: number;
  xScale: d3.ScaleTime<number, number, never>;
  yScale: d3.ScaleLinear<number, number, never>;
};

const OutOfRetention = ({ retention, yScale, xScale }: OutOfRetentionProps) => {
  const intl = useIntl();

  if (!retention) {
    return null;
  }

  const height = yScale.range()[0];
  const width = xScale(Date.now() - retention * 60_000);

  if (width <= 0) {
    return null;
  }

  return (
    <g>
      <S.OutOfRetentionRect x={0} y={0} height={height} width={width} />
      <S.OutOfRetentionText
        y={height / 2}
        x={width / 2}
        textAnchor="middle"
        alignmentBaseline="middle"
      >
        {intl.formatMessage({ id: "out_of_retention" })}
      </S.OutOfRetentionText>
    </g>
  );
};

export default OutOfRetention;
